import { render, staticRenderFns } from "./RewardPeriodDetailRequests.vue?vue&type=template&id=77f30cd0"
import script from "./reward-period-detail-requests.ts?vue&type=script&lang=ts&external"
export * from "./reward-period-detail-requests.ts?vue&type=script&lang=ts&external"
import style0 from "./reward-period-detail-requests.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports